import { HEX_RADIUS } from "../config/mapLayout.ts";

/** Flat-top axial → world XZ (y up). Copied arithmetic identity for host layout. */
export function gridToWorld(
  q: number,
  r: number,
  hexRadius = HEX_RADIUS,
  out?: { x: number; y: number; z: number },
): { x: number; y: number; z: number } {
  const x = hexRadius * 1.5 * q;
  const z = hexRadius * Math.sqrt(3) * (r + q / 2);
  if (out) {
    out.x = x;
    out.y = 0;
    out.z = z;
    return out;
  }
  return { x, y: 0, z };
}
